module.exports = __webpack_public_path__ + "img/文化部.f4307897.png";